import { render, staticRenderFns } from "./ModalDataLoader.vue?vue&type=template&id=2f96e9a1&scoped=true&"
import script from "./ModalDataLoader.vue?vue&type=script&lang=js&"
export * from "./ModalDataLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96e9a1",
  null
  
)

export default component.exports